import state from './state';
import mutations from './mutations';
import * as types from './mutations-types'
import * as actions from './actions';
import * as getters from './getters';
export default {
    namespaced: true,     //命名空间
    state,
    actions,
    getters,
    mutations,
    types,
};
